export default __webpack_public_path__ + "static/f5dbadcb2364f9cdd2705807700e0880.png";